<template>

<app-input :prefix="prefix" :label="label" :stacked="stacked" :no-line="noLine" :notes="notes" :locked="locked" :disabled="disabled" :validation="validation">

	<transition-group name="listtransition" tag="div" class="gallery" v-if="!list">

		<div class="gallery-item" v-for="(item, index) in items" :key="item.id" v-bgimage="item.image">

			<div class="gallery-item-name">{{ item.text }}</div>

			<app-icon icon="caret-left" v-tooltip="'Move left'" class="gallery-item-button" v-on:click.native="onLeftClick(index)" :disabled="index === 0" />
			<app-icon icon="delete" v-tooltip="'Remove item'" class="gallery-item-button" v-on:click.native="onDeleteClick(index)" />
			<app-icon icon="caret-right" v-tooltip="'Move right'" class="gallery-item-button" v-on:click.native="onRightClick(index)" :disabled="index === value.length - 1" />

		</div>

		<div class="gallery-item is-insert" key="insert" v-tooltip="'Click to insert'" v-on:click="onInsertClick">{{ placeholder }}</div>

	</transition-group>

	<transition-group name="listtransition" tag="div" class="list" v-if="list">

		<div class="list-item" v-for="(item, index) in items" :key="item.id">

			<div class="list-item-name">{{ item.text }}</div>
			<div class="list-item-price">{{ item.price | formatMoney }}</div>

			<div class="list-item-buttons">

				<app-icon icon="delete" v-tooltip="'Remove'" class="list-item-button is-danger" v-on:click.native="onDeleteClick(index)" />
				<app-icon icon="caret-up" v-tooltip="'Move up'" class="list-item-button is-neutral" v-on:click.native="onLeftClick(index)" :disabled="index === 0" />
				<app-icon icon="caret-down" v-tooltip="'Move down'" class="list-item-button is-neutral" v-on:click.native="onRightClick(index)" :disabled="index === value.length - 1" />

			</div>

		</div>

		<div v-if="!value.length" class="list-item is-insert" key="insert">
			<div class="list-item-name">{{ placeholder }}</div>
		</div>

	</transition-group>

	<app-icon v-if="list" icon="create-circle" class="list-add" v-tooltip="'Add input'" v-on:click.native="onInsertClick" />

	<com-find v-if="is.expanded" v-on:close="onPanelClose" :exclude="value" :api="api" :params="params" v-on:save="onItemsAdd" />

</app-input>

</template>

<script>

import comFind from './items/Find'

export default {

	props: ['label', 'api', 'prefix', 'list', 'params', 'locked', 'validation', 'disabled', 'value', 'noLine', 'stacked', 'placeholder', 'notes'],

	components: {
		'com-find': comFind
	},

	data: function() {

		return {
			is: {
				expanded: false
			},
			items: []
		}

	},

	watch: {

		value: function() {

			this.getItems()

		}

	},

	created: function() {

		this.getItems()

	},

	computed: {

		selectedItem: function() {

			return (this.is.expanded === true || this.is.expanded === false) ? false : this.value[this.is.expanded - 1]

		}

	},

	methods: {

		getItems: async function() {

			if (this.value.length) {

				var items = []

				await this.$api.get(['suggest', this.api, this.value.join(',')]).then(function(json) {

					if (json.suggestion) {

						items.push(json.suggestion)

					} else {

						this.$_.each(this.value, function(id) {

							items.push(this.$_.findWhere(json.suggestions, {
								id: id
							}))

						}.bind(this))

					}

				}.bind(this))

				this.items = items

			} else {

				this.items = []

			}

		},

		onLeftClick: function(index) {

			if (index > 0) {

				var value = this.$util.copy(this.value)

				var removed = value.splice(index, 1)

				value.splice(index - 1, 0, removed[0])

				this.$emit('input', value)

			}

		},

		onRightClick: function(index) {

			if (index < this.value.length) {

				var value = this.$util.copy(this.value)

				var removed = value.splice(index, 1)

				value.splice(index + 1, 0, removed[0])

				this.$emit('input', value)

			}

		},

		onDeleteClick: function(index) {

			var value = this.$util.copy(this.value)

			value.splice(index, 1)

			this.$emit('input', value)

		},

		onItemsAdd: function(index) {

			var value = this.$util.copy(this.value)

			this.$_.each(index, function(id) {

				if (!this.$_.contains(value, id)) value.push(id)

			}.bind(this))

			this.$emit('input', value)

			this.onPanelClose()

		},

		onInsertClick: function() {

			if (!this.is.expanded) {

				this.is.expanded = true

			}

		},

		onPanelClose: function() {

			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

.listtransition-move,
.listtransition-enter-active,
.listtransition-leave-active {
	transition: all 0.5s ease;
}

.listtransition-enter-from,
.listtransition-leave-to {
	opacity: 0;
}

.listtransition-leave-active {
	position: absolute;
}

.list {
	display: flex;
	flex-direction: column;
}

.list-item {
	border: 2px solid #eee;
	min-height: 40px;
	display: flex;
	align-items: center;
	border-top-width: 0px;
}

.list-item:first-child {
	border-top-left-radius: 12px;
	border-top-right-radius: 12px;
	border-top-width: 2px;
}

.list-item:last-child {
	border-bottom-left-radius: 12px;
	border-bottom-right-radius: 12px;
}

.list-item-name {
	flex-grow: 1;
	font-size: 14px;
	padding: 4px 10px;
	flex-basis: 0;
	flex-shrink: 0;
}

.list-item-price {
	padding-right: 10px;
	font-size: 14px;
	width: 160px;
}

.list-item-buttons {
	flex-shrink: 0;
	display: flex;
}

.list-item-button {
	width: 24px;
	height: 24px;
	cursor: pointer;
	font-size: 14px;
	border-radius: 4px;
	line-height: 26px;
	text-align: center;
	background-color: #4082d3;
	color: #fff;
	margin-right: 10px;
}

.list-item-button.is-neutral {
	background-color: #ddd;
	color: #666;
}

.list-item-button.is-danger {
	background-color: #c55b5b;
}

.list-add {
	font-size: 24px;
	color: #4082d3;
	position: absolute;
	left: -28px;
	cursor: pointer;
	top: 8px;
}

.list-item.is-insert .list-item-name {
	color: #999;
}

.gallery {   
	min-height: 160px;
	display: flex;
	padding: 5px;
}

.gallery-item {
	width: 160px;
	height: 160px;
	border-radius: 10px;
	background-position: 50% 50%;
	background-size: cover;
	margin: 5px 5px 32px 5px;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	user-select: none;
	background-color: #fff;
}

.gallery-item-name {
	position: absolute;
	bottom: -32px;
	left: 0px;
	width: 100%;
	text-align: center;
	color: #687589;
	font-size: 14px;
	line-height: 32px;
	height: 32px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	font-weight: 400;
}

.gallery-item-button {
	width: 32px;
	height: 32px;
	cursor: pointer;
	line-height: 32px;
	text-align: center;
	font-size: 16px;
	z-index: 2;
	color: #fff;
	opacity: 0;
	transition: opacity 100ms linear;
}

.gallery-item:not(.is-insert):before {
	content: '';
	background: linear-gradient(180deg, rgba(255,255,255,0.15) 0%, rgba(0,0,0,0.5) 100%);
	position: absolute;
	left: 0px;
	transition: opacity 100ms linear;
	top: 0px;
	width: 160px;
	height: 160px;
	z-index: 1;
	border-radius: 10px;
	opacity: 0;
}


.gallery-item:hover .gallery-item-button,
.gallery-item:hover:before {
	opacity: 1;
}

.gallery-item.is-insert {
	align-items: center;
	border: 2px dashed #eee;
	font-size: 24px;
	margin-bottom: 5px;
	text-align: center;
	padding: 10px;
	color: #ddd;
	cursor: pointer;
	font-weight: 500;
}

.gallery-item.is-insert:hover {
	border-color: #ccc;
	color: #ccc;
}

</style>
